import { AreaProjectModel } from '../../generated';
import { ExtendedAreaProject } from '../api-utilities.types';

const getApiObjectLayerRaster = ({ mapboxTilesetId }: ExtendedAreaProject | AreaProjectModel) =>
    mapboxTilesetId ? `https://api.mapbox.com/v4/${mapboxTilesetId}` : null;

export { getApiObjectLayerRaster };
